import React from "react";
import { CellRenderers, columnRenderArrayData } from "utils/tableUtils";
import GenericPullConfigListing from "../GenericPullConfigListing";
import MicrosoftDefenderForEndpointCredentialsForm from "./MicrosoftDefenderForEndpointCredentialsForm";
import MicrosoftDefenderForEndPointMappingForm from "./MicrosoftDefenderForEndpointMappingForm";
import MicrosoftDefenderForEndPointMappingFormV2 from "./MicrosoftDefenderForEndPointMappingFormV2"
import { capitalize, split, map } from "utils/lodashUtils";
import { useFeatureFlag } from "contexts/FeatureFlagContext";

export default function MicrosoftDefenderForEndpointConfigListing(props) {
  const featureFlags = useFeatureFlag();

  const columns = [
    {
      title: "Integration Type",
      dataIndex: "integrationType",
      width: 240,
      render: capitalize,
    },
    {
      title: "Machines",
      dataIndex: "machineName",
      width: 240,
      render: columnRenderArrayData,
    },
    {
      title: "Tags with Machine Names",
      dataIndex: "tagWithMachineName",
      width: 240,
      render: (tagWithMachine, record) => {
        if (record.integrationType === "TAG") {
          return columnRenderArrayData(
            map(split(tagWithMachine, ","), (pair) => {
              const [key, values] = pair.split(":");
              return `${key} ${values ? `- ${values.split(";").join()}` : ""}`;
            }).join()
          );
        }
        return CellRenderers.VALUE_OR_NA();
      },
    },
  ];

  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={featureFlags.MICROSOFT_DEFENDER_FOR_ENDPOINT_ADVANCED_HUNTING ? MicrosoftDefenderForEndPointMappingFormV2: MicrosoftDefenderForEndPointMappingForm}
      CredentialsForm={MicrosoftDefenderForEndpointCredentialsForm}
      extraColumns={columns}
      displayComponentName="Device/Tag"
    />
  );
}
